const facilities = [
  {
    id: "cr-usps-main",
    name: "Cedar Rapids Main Post Office",
    type: "USPS Passport Acceptance",
    address: "615 6th Avenue SE",
    city: "Cedar Rapids",
    state: "IA",
    zip: "52401",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm, Sat 9am–12pm",
    distance: "Downtown Cedar Rapids",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Confirm photo services when booking.",
    icon: "ri-mail-line",
  },
  {
    id: "cr-usps-west",
    name: "Westdale Post Office",
    type: "USPS Passport Acceptance",
    address: "2000 Glass Road NE",
    city: "Cedar Rapids",
    state: "IA",
    zip: "52402",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Northeast Cedar Rapids",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Northeast Cedar Rapids option. Call ahead to confirm passport acceptance hours.",
    icon: "ri-mail-line",
  },
  {
    id: "cr-usps-marion",
    name: "Marion Post Office",
    type: "USPS Passport Acceptance",
    address: "3800 Bowling Street SW",
    city: "Marion",
    state: "IA",
    zip: "52302",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Marion (~5 mi south of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "South suburb option. Confirm appointment and photo availability.",
    icon: "ri-mail-line",
  },
  {
    id: "cr-usps-hiawatha",
    name: "Hiawatha Post Office",
    type: "USPS Passport Acceptance",
    address: "101 Emmons Street",
    city: "Hiawatha",
    state: "IA",
    zip: "52233",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Hiawatha (~4 mi north of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "North suburb option. Call to confirm passport services and appointment requirements.",
    icon: "ri-mail-line",
  },
  {
    id: "cr-linn-clerk",
    name: "Linn County Clerk of Court",
    type: "County Clerk Passport Acceptance",
    address: "50 3rd Avenue Bridge",
    city: "Cedar Rapids",
    state: "IA",
    zip: "52401",
    phone: "319-892-5300",
    hours: "Mon–Fri 8am–4:30pm",
    distance: "Downtown Cedar Rapids",
    website: "https://www.linncounty.org/",
    websiteLabel: "Clerk Passport Info",
    notes: "Linn County acceptance option. Confirm appointments and accepted payments before visiting.",
    icon: "ri-government-line",
  },
  {
    id: "cr-usps-iowacity",
    name: "Iowa City Post Office",
    type: "USPS Passport Acceptance",
    address: "925 South Gilbert Street",
    city: "Iowa City",
    state: "IA",
    zip: "52240",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Iowa City (~25 mi south of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Johnson County option. Appointment required. Confirm photo services when booking.",
    icon: "ri-mail-line",
  },
];

export default function CedarRapidsAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Passport Acceptance Clerks
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Cedar Rapids, IA
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-6">
            First-time applicants must apply in person at a passport acceptance clerk, and all locations require an appointment. This is the self-service option, typically chosen by those on a tighter budget with at least 1–2+ months before travel.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-amber-600 text-base"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                If you want to use a registered U.S. Department of State courier to receive your passport in as little as 3 days, you must sign up with{" "}
                <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">
                  Fast Passport Center
                </a>{" "}
                <strong>before</strong> going to the clerk. Once you apply at the clerk, your documents are sent through the standard route, and we cannot intervene afterward.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f) => (
            <article key={f.id} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${f.icon} text-[#F6C344] text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>

              <div className="space-y-2 flex-1">
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.address}, {f.city}, {f.state} {f.zip}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={`tel:${f.phone.replace(/-/g, "")}`} className="hover:text-[#1A365D] transition-colors">{f.phone}</a>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <span>{f.distance}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={f.website} target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">
                    {f.websiteLabel}
                  </a>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex items-start gap-2 mb-3">
                  <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    <i className="ri-calendar-line text-xs"></i> Appointment Required
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-relaxed italic">{f.notes}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-xl"></i>
            </div>
            <div>
              <p className="font-bold text-white text-base mb-1">Last chance — sign up now, before your clerk visit</p>
              <p className="text-white/70 text-sm leading-relaxed max-w-xl">
                If you need your expedited passport fast, sign up with Fast Passport Center <strong className="text-white">before</strong> you walk into that clerk appointment. Once your documents go through the standard route, there is no pulling them back.
              </p>
            </div>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}